import api from 'Application/api/api';

const getCurrentEmployeeTasksProgress = (cancelToken = null) =>
    api.get('/employees/current/tasks-progress', {
        cancelToken,
    });

export default getCurrentEmployeeTasksProgress;
